import { useEffect, useState } from "react";
import { codigosRespuesta, IResponseApiFluent } from "../../../../../Interfaces/base/IResponse";
import { IPanelEliminarEquipoModeloOperador } from "./PanelEliminarEquipoModeloOperador";
import { IEquipoModeloOperadorCommand } from "../../../../../Interfaces/auxiliar/IOperador";
import { EquipoModeloOperadorService } from "../../../../../services/auxiliar/EquipoModeloOperadorService";

export const UsePanelEliminarEquipoModeloOperador=(props:IPanelEliminarEquipoModeloOperador)=>{
      const [status, setStatus] = useState<codigosRespuesta>(0);
      const [mensaje, setMensaje] = useState<string>("");
      const [loading,setLoading]=useState<boolean>(false)
      const initial:IEquipoModeloOperadorCommand={
          equipoModeloId: "",
          operadorId: "",
      }
      const [request,setRequest]=useState<IEquipoModeloOperadorCommand>(initial)
      const reset=()=>{
          setMensaje("")
          setRequest(initial)
          setStatus(0)
          props.onDismiss()
      }
      useEffect(()=>{
          if(props.isOpen){
            setRequest({...request,equipoModeloId:props.item.equipoModeloId,operadorId:props.item.operadorId})
            }
      },[props.isOpen])
      const putEditarCatalogo=()=>{
        setLoading(true)
        EquipoModeloOperadorService.Eliminar(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status}


}